import { CloseIcon } from 'components/icons/CloseIcon';
import { ModalContext } from 'context/ModalContext';
import { useContext, useRef, useState } from 'react';
import { MODAL_TYPES } from '../constants';
import api from 'services/api';

interface IEditSpeakerProfile {
  onCancel: () => void;
  selectedPerson: any;
  peopleData: any[];
  setPeopleData: any;
}

export default function EditSpeakerProfile({
  onCancel,
  selectedPerson,
  peopleData,
  setPeopleData
}: IEditSpeakerProfile) {
  const { showModal, hideModal } = useContext(ModalContext);
  const [formData, setFormData] = useState({
    name: selectedPerson.name || '',
    personal_bio: selectedPerson.personal_bio || '',
    company: selectedPerson.company || '',
    title: selectedPerson.title || ''
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const inputRef = useRef(null as any);

  function onSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        showModal(MODAL_TYPES.profile_image_upload, {
          imgSrc: reader.result?.toString() || '',
          selectedPerson: { ...selectedPerson, ...formData },
          setPeopleData,
          peopleData
        })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  const handleEditClick = () => {
    inputRef.current.click();
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    api
      .put(`api/zoom/event/sessions/${selectedPerson.session_id}/speakers/${selectedPerson.hash_id}/update/`, {
        ...formData
      })
      .then((res) => {
        const newPeopleList = peopleData.map((person: any) => {
          if (person.hash_id === res.data.hash_id) {
            // Update the properties of the person
            return res.data;
          }
          return person;
        });
        setPeopleData(newPeopleList);
        hideModal();
      });
  };

  const openRemove = () => {
    showModal(MODAL_TYPES.remove_profile_image, {
      selectedPerson: { ...selectedPerson, ...formData },
      setPeopleData,
      peopleData
    });
  };

  return (
    <div className="transparent font-lato">
      <input type="file" accept="image/*" className="hidden" ref={inputRef} onChange={onSelectFile} />

      <form onSubmit={handleSubmit}>
        <div className="relative border bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[700px] md:min-h-[300px] rounded-t-lg">
          <div className="flex">
            <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Edit speaker profile</span>
            <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
          </div>
          <div className="flex">
            <div className="flex-1">
              <p className="mb-3 font-bold mt-7">Full name</p>
              <input
                type="text"
                id="name"
                name="name"
                value={formData['name']}
                className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
                onChange={handleInputChange}
              />
              {!formData['name'] && <p className="mb-4 text-red-500">Unfortunately, you can’t leave this blank.</p>}
              <p className="mb-3 font-bold">Company</p>
              <input
                type="text"
                id="company"
                name="company"
                value={formData['company']}
                className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
                onChange={handleInputChange}
              />
              <p className="mb-3 font-bold">Title</p>
              <input
                type="text"
                id="title"
                name="title"
                value={formData['title']}
                className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
                onChange={handleInputChange}
              />
              <p className="mb-3 font-bold">About</p>
              <textarea
                className="border border-gray-300 rounded-md px-3 py-2 w-full mb-2"
                id="personal_bio"
                name="personal_bio"
                value={formData['personal_bio']}
                spellCheck="false"
                rows={5}
                onChange={handleInputChange}
              />
            </div>
            <div className="pl-5 min-w-[200px]">
              <p className="mb-3 font-bold mt-7">Profile photo</p>
              <img
                className="rounded-[4px] cursor-pointer w-52"
                src={selectedPerson?.photo ?? '/assets/img/user.png'}
                alt={`${name} - Image`}
              />
              <button
                type="button"
                className="peer-focus:block bg-white border bg-opacity-20 border-[#ced4da] cursor-pointer text-black px-2 py-1 rounded-sm w-full my-3"
                onClick={handleEditClick}
              >
                Upload Photo
              </button>
              {selectedPerson.photo && (
                <p className="text-blue-text mx-auto text-center cursor-pointer hover:underline" onClick={openRemove}>
                  Remove Photo
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="flex text-[13px] py-4 px-4 bg-white rounded-b-lg border-x">
          <button
            className="py-2 px-3 text-black border border-[#e7eaec] ml-auto rounded-md hover:bg-gray-200"
            onClick={hideModal}
          >
            Cancel
          </button>
          <button className="bg-[#1ab394] py-2 px-4 text-white ml-2 rounded-md" type="submit">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}
